import React, { useState } from 'react';
import classNames from 'classnames';

interface CustomCheckboxProps {
  label: string;
  name: string;
  className?: string;
}

export const CustomCheckbox: React.FC<CustomCheckboxProps> = ({
  label,
  name,
  className,
}) => {
  const [checked, setChecked] = useState(false);

  const toggleCheckbox = () => {
    setChecked((value) => !value);
  };

  return (
    <label
      className={classNames(
        'flex cursor-pointer select-none items-center gap-4',
        className
      )}
    >
      <input
        type='checkbox'
        name={name}
        checked={checked}
        className='pointer-events-none hidden'
        onChange={toggleCheckbox}
      />
      <div
        className={`flex h-6 w-6 min-w-6 items-center justify-center rounded-md border-2 transition-colors duration-300 ${
          checked
            ? 'border-accent-primary bg-accent-primary'
            : 'border-checkbox-border bg-checkbox-bg'
        }`}
      >
        {checked && (
          <svg
            xmlns='http://www.w3.org/2000/svg'
            className='h-4 w-4 text-white'
            viewBox='0 0 20 20'
            fill='currentColor'
          >
            <path
              fillRule='evenodd'
              d='M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z'
              clipRule='evenodd'
            />
          </svg>
        )}
      </div>
      <span className='text-gray-700 th-rio:text-text-primary'>{label}</span>
    </label>
  );
};
